function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import HourPicker from './_hourPicker.class';
var searchModule = /*#__PURE__*/function () {
  function searchModule(picker) {
    _classCallCheck(this, searchModule);
    this.picker = picker;

    //Class attributes to be defined on constructor
    try {
      this.json = JSON.parse(document.querySelector('#searchModule').getAttribute('data-searchParameter'));
    } catch (e) {
      console.error('Error while parsing JSON data', e);
      this.json = null;
    }
    this.minStartDate = null;
    this.maxStartDate = null;
    this.minEndDate = null;
    this.maxEndDate = null;
    if (this.json) {
      this.interval = this.json['interval'];
      this.availableDates = Object.keys(this.json['availableDates']);
    } else {
      this.interval = 0;
      this.availableDates = [];
    }
    this.startDatePicker = null;
    this.endDatePicker = null;
    this.startHourPicker = null;
    this.endHourPicker = null;
    if (this.json) {
      //Initialize parameters attributes
      this.initializeSearchParameters();
    }
  }
  return _createClass(searchModule, [{
    key: "initializeStartDatePicker",
    value: function initializeStartDatePicker() {
      this.picker.initializeStartDatePicker(this, this.minStartDate, this.maxStartDate);
    }
  }, {
    key: "initializeEndDatePicker",
    value: function initializeEndDatePicker() {
      this.minEndDate = this.formatDate(this.startDatePicker.dateValue);
      this.maxEndDate = this.availableDates[this.availableDates.indexOf(this.minEndDate) + 3];
      this.picker.initializeEndDatePicker(this, this.minEndDate, this.maxEndDate);
    }
  }, {
    key: "setPickers",
    value: function setPickers(dates, hours) {
      this.picker.setPickers(this, dates, hours);
    }
  }, {
    key: "setStartDate",
    value: function setStartDate(date) {
      this.picker.setStartDate(this, date);
    }
  }, {
    key: "setEndDate",
    value: function setEndDate(date) {
      this.picker.setEndDate(this, date);
    }
  }, {
    key: "initializeSearchParameters",
    value: function initializeSearchParameters() {
      this.minStartDate = this.availableDates[0];
      this.maxStartDate = this.availableDates[this.availableDates.length - 4];
      this.minEndDate = this.availableDates[0];
      this.maxEndDate = this.availableDates[this.availableDates.length - 1];
    }
  }, {
    key: "appendErrorMessage",
    value: function appendErrorMessage(target, message) {
      document.querySelector(target).insertAdjacentHTML('beforeend', "<div class=\"o-search-module-truck__error js-formError mu-mt-050\"><p class=\"u-error-message\">\n                ".concat(message, "\n            </p></div>"));
    }
  }, {
    key: "createDateHour",
    value: function createDateHour(hour, min) {
      var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var date = new Date();
      date.setHours(hour);
      date.setMinutes(min);
      if (increment) {
        date.setMinutes(date.getMinutes() + this.json['minimalDuration']);
      }
      return date;
    }
  }, {
    key: "compareDate",
    value: function compareDate(d1, d2) {
      var date1 = d1.split(':');
      var date2 = d2.split(':');
      return this.createDateHour(date1[0], date1[1]) > this.createDateHour(date2[0], date2[1]);
    }
  }, {
    key: "initializeHourPicker",
    value: function initializeHourPicker(prmStep) {
      var _this = this;
      var element = document.querySelector(".js-".concat(prmStep, "Date"));
      var _searchModule = this;
      if (element.querySelector("select[name=\"".concat(prmStep, "HourPicker\"]")) !== null) {
        element.querySelector("select[name=\"".concat(prmStep, "HourPicker\"]")).removeAttribute('disabled');
      }
      var plages = [];
      var dateKey = _searchModule.formatDate(prmStep === 'start' ? _searchModule.startDatePicker.dateValue : _searchModule.endDatePicker.dateValue);
      var plagesBrutes = _searchModule.json.availableDates[dateKey];
      if (!plagesBrutes || plagesBrutes.length === 0) {
        var target = ".js-".concat(prmStep, "Date");
        var msg = "D\xE9sol\xE9, votre magasin n'est pas disponible \xE0 cette date pour ".concat(prmStep === 'start' ? "l'obtention" : 'la restitution', " d'un v\xE9hicule");
        this.appendErrorMessage(target, msg);
        return null;
      }

      // Conversion en plages de [start, end]
      for (var i = 0; i < plagesBrutes.length; i += 2) {
        if (plagesBrutes[i + 1]) {
          plages.push([plagesBrutes[i], plagesBrutes[i + 1]]);
        }
      }

      // Si end picker est sur la même date que start, appliquer la minDuration
      if (prmStep === 'end' && dateKey === _searchModule.formatDate(_searchModule.startDatePicker.dateValue)) {
        var startTime = _searchModule.startHourPicker.hourValue.toString().split(':');
        var minEnd = this.createDateHour(startTime[0], startTime[1], true);
        var minEndStr = "".concat(minEnd.getHours().toString().padStart(2, '0'), ":").concat(minEnd.getMinutes().toString().padStart(2, '0'));

        // Trouver la première plage qui commence après minEnd
        plages = plages.map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            start = _ref2[0],
            end = _ref2[1];
          if (_this.compareDate(minEndStr, end)) return [minEndStr, end];
          if (_this.compareDate(start, minEndStr)) return null;
          return [start, end];
        }).filter(function (p) {
          return p;
        });
      }
      if (plages.length === 0 || this.compareDate(plages[0][0], plages[0][1])) {
        var _target = ".js-".concat(prmStep, "Date");
        var _msg = "D\xE9sol\xE9, votre magasin n'est pas disponible \xE0 cette date pour ".concat(prmStep === 'start' ? "l'obtention" : 'la restitution', " d'un v\xE9hicule");
        this.appendErrorMessage(_target, _msg);
        return null;
      }
      var parameters = {
        element: "select[name=\"".concat(prmStep, "HourPicker\"]"),
        hour: {
          slots: plages,
          step: 1
        },
        minuteInterval: _searchModule.interval
      };
      if (prmStep === 'start') {
        parameters.onValueUpdate = function () {
          if (_searchModule.endDatePicker.value !== undefined) {
            _searchModule.endDatePicker.dateValue = _searchModule.endDatePicker.value;
          }
          if (_searchModule.endHourPicker !== null && _searchModule.endHourPicker.hourValue !== '') {
            _searchModule.endHourPicker = null;
          }
          if (_searchModule.endDatePicker.dateValue !== '') {
            _searchModule.submitSearch('end');
          }
        };
      }
      if (prmStep === 'end') {
        parameters.onValueUpdate = function () {
          _searchModule.enableSubmission();
        };
      }
      return new HourPicker(parameters);
    }
  }, {
    key: "submitSearch",
    value: function submitSearch() {
      var prmStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (document.querySelector('.js-formError')) {
        var errorElement = document.querySelector('.js-formError');
        errorElement.parentNode.removeChild(errorElement);
      }
      try {
        document.querySelector('input[name="startDate"]').removeAttribute('style');
        document.querySelector('input[name="endDate"]').removeAttribute('style');
        document.querySelector('select[name="startHourPicker"]').removeAttribute('style');
        document.querySelector('select[name="endHourPicker"]').removeAttribute('style');
      } catch (exception) {
        console.error(exception);
      } finally {
        var _searchModule2 = this;
        _searchModule2.allowSearchModule();
        switch (prmStep) {
          case 'start':
            _searchModule2.startHourPicker = _searchModule2.initializeHourPicker('start');
            _searchModule2.initializeEndDatePicker();
            break;
          case 'end':
            _searchModule2.endHourPicker = _searchModule2.initializeHourPicker('end');
            break;
          default:
            break;
        }
        _searchModule2.allowSearchModule(true);
        _searchModule2.enableSubmission();
      }
    }
  }, {
    key: "submitFormular",
    value: function submitFormular() {
      var _searchModule3 = this;
      var buttonSearch = document.querySelector('.js-searchTruck');
      var storeCode = buttonSearch.getAttribute('data-store');
      var latitude = buttonSearch.getAttribute('data-latitude');
      var longitude = buttonSearch.getAttribute('data-longitude');
      var truckTypes = JSON.parse(buttonSearch.parentElement.getAttribute('data-truck'));
      buttonSearch.setAttribute('disabled', 'disabled');
      return new Promise(function (resolve, reject) {
        lm.fetch({
          url: '/services/trucks',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Cache: 'no-cache'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            startDate: _searchModule3.startDatePicker.dateValue.split('/').reverse().join('-'),
            startTime: _searchModule3.startHourPicker.hourValue.toString(),
            endDate: _searchModule3.endDatePicker.dateValue.split('/').reverse().join('-'),
            endTime: _searchModule3.endHourPicker.hourValue.toString(),
            storeCode: storeCode,
            latitude: latitude,
            longitude: longitude,
            truckTypes: truckTypes
          }),
          success: function success(response) {
            resolve(response);
          },
          error: function error(_error) {
            reject(_error);
          }
        });
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      return date.split('/').reverse().join('-');
    }
  }, {
    key: "allowSearchModule",
    value: function allowSearchModule() {
      var prmStage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var formular = document.querySelector('.js-truck-search-form');
      var inputs = formular.querySelectorAll('input');
      var selects = formular.querySelectorAll('select');
      var _iterator = _createForOfIteratorHelper(inputs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          if (prmStage) {
            element.removeAttribute('disabled');
          } else {
            element.setAttribute('disabled', 'disabled');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(selects),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element = _step2.value;
          if (prmStage) {
            _element.removeAttribute('disabled');
          } else {
            _element.setAttribute('disabled', 'disabled');
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "enableSubmission",
    value: function enableSubmission() {
      document.querySelector('.search-form-error') && document.querySelector('.search-form-error').remove();
      var buttonElement = document.querySelector('.js-searchTruck');
      if (buttonElement.getAttribute('disabled')) {
        buttonElement.removeAttribute('disabled');
      }
      if (this.endHourPicker === null) {
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      } else if (this.endHourPicker.hourValue === null) {
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      }
      if (this.startDatePicker !== null && this.startDatePicker.dateValue === '') {
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      }
      if (this.endDatePicker !== null && this.endDatePicker.dateValue === '' || this.endDatePicker !== null && this.endDatePicker.dateValue === undefined) {
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      }
      if (this.startHourPicker !== null && this.startHourPicker.hourValue === null) {
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      }
      var startdate = '',
        enddate = '',
        formattedStartDate = '',
        formattedEndDate = '',
        startdateyear = '',
        startdatemonth = '',
        startdateday = '',
        enddateyear = '',
        enddatemonth = '',
        enddateday = '';
      var isMobile = this.startDatePicker.dateValue.includes('-') && this.endDatePicker.dateValue.includes('-');
      startdate = this.startDatePicker.dateValue.split(isMobile ? '-' : '/');
      enddate = this.endDatePicker.dateValue.split(isMobile ? '-' : '/');
      if (isMobile) {
        var _startdate = startdate;
        var _startdate2 = _slicedToArray(_startdate, 3);
        startdateyear = _startdate2[0];
        startdatemonth = _startdate2[1];
        startdateday = _startdate2[2];
        var _enddate = enddate;
        var _enddate2 = _slicedToArray(_enddate, 3);
        enddateyear = _enddate2[0];
        enddatemonth = _enddate2[1];
        enddateday = _enddate2[2];
      } else {
        var _startdate3 = startdate;
        var _startdate4 = _slicedToArray(_startdate3, 3);
        startdateday = _startdate4[0];
        startdatemonth = _startdate4[1];
        startdateyear = _startdate4[2];
        var _enddate3 = enddate;
        var _enddate4 = _slicedToArray(_enddate3, 3);
        enddateday = _enddate4[0];
        enddatemonth = _enddate4[1];
        enddateyear = _enddate4[2];
      }
      formattedStartDate = new Date("".concat(startdateyear, "-").concat(startdatemonth, "-").concat(startdateday, "T").concat(this.startHourPicker.hourValue));
      formattedEndDate = new Date("".concat(enddateyear, "-").concat(enddatemonth, "-").concat(enddateday, "T").concat(this.endHourPicker.hourValue));
      if (formattedStartDate >= formattedEndDate) {
        document.querySelector('.search-module__result').classList.remove('is-visible');
        document.querySelector('.search-module__result').classList.add('is-hidden');
        var form = document.querySelector('.js-truck-search-form');
        form.insertAdjacentHTML('afterend', '<div class="search-form-error oss-text-danger mu-mt-100"><svg class="ku-icon-16 oss-fill-red mu-mr-050" aria-hidden="true"><use href="#Navigation_Control_Cross_24px"></use></svg>La date de fin est avant la date de début. Veuillez saisir des informations valides.</div>');
        buttonElement.setAttribute('disabled', 'disabled');
        return;
      }
    }
  }]);
}();
export default searchModule;